import styled from 'styled-components';

export const ToggleContainer = styled.div`
    height: 20px;
    width: 30px;
    position: relative;
    cursor: pointer;
`;

export const ToggleBar = styled.div`
    background-color: ${({ value, theme }) => (value ? theme.colors.pastelPrimary100 : theme.colors.neutral100)};
    position: absolute;
    height: 18px;
    width: 50px;
    border-radius: 32px;
    padding: 4px;
    display: flex;
    border: ${({ value, theme }) => (value ? `1px solid ${theme.colors.primary300}` : 'none')}
`;

export const ToggleSphere = styled.div`
    background-color: ${({ value, theme }) => (value ? theme.colors.primary300 : theme.colors.neutral700)};
    border-radius: 100px;
    width: 18px;
    height: 18px;
    position: absolute;
    transform: translateX(${({ value }) => (value ? '30px' : '1px')});
    transition-duration: 100ms;
    transition-timing-function: ease-in-out;
`;

export const ToggleBarText = styled.div`
    font-size: 11px;
    transform: translateX(${({ value }) => (value ? '2px' : '25px')});
    font-weight: 600;
    margin-top: 2px;
    color: ${({ value, theme }) => (value ? theme.colors.primary300 : theme.colors.neutral700)};
`;
